/* Agreed with the client: an order of twenty distinct parts or more is
   scheduled rather than sent out with the next delivery run. */
export const DELIVERY_SCHEDULE_THRESHOLD = 20;

/* Both paths that fill the cart run their response through reduceData (see
   redux/cart/thunks), so `part_id` is there whether the items came from the
   cart's own fetch or from addItems after a quantity edit.

   The fallback is for the day that stops being true. Counting by Set means a
   missing id is not a small error: every line without one lands on the same
   entry, so a twenty-five line order would count as one and go out without ever
   asking for a delivery date - silently, since nothing else on the screen reads
   this. A line with no id gets a token of its own instead, prefixed so it cannot
   collide with a real part id, which the API sends as a number. */
const partKey = (item) => {
  const partId = item?.part_id;
  if (partId !== undefined && partId !== null) return partId;
  return `line:${item?.id}`;
};

/* What the delivery threshold is measured against: distinct parts to pick, not
   lines and not quantity - twenty of one part is one thing to fetch off a shelf.

   Orders the client already has waiting count toward the same delivery, so a
   small cart on top of several pending ones is still a big delivery. A part in
   both is one part to pick, so the two are merged rather than added. */
export const countScheduledParts = (cartItems = [], pendingSummary) => {
  const partIds = new Set(pendingSummary?.pending_part_ids || []);
  cartItems.forEach((item) => partIds.add(partKey(item)));
  return partIds.size;
};

export const needsDeliverySchedule = (cartItems, pendingSummary) =>
  countScheduledParts(cartItems, pendingSummary) >= DELIVERY_SCHEDULE_THRESHOLD;

export const hasPendingOrders = (pendingSummary) => (pendingSummary?.pending_orders_count || 0) > 0;
